export const TAILIEU_SET_LIST_DATA = 'TAILIEU_SET_LIST_DATA';
export const TAILIEU_SET_LIST_META = 'TAILIEU_SET_LIST_META';

export const TAILIEU_TITLE = 'Tài Liệu';